var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 113,
    viewBox: "0 0 72 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4823 85.2165L50.8452 90.7863C57.2852 92.5354 61.1033 95.2519 61.1033 97.3234C61.1033 100.685 51.1674 105.751 36.2128 105.751C21.2582 105.751 11.3224 100.685 11.3224 97.3234C11.3224 95.2519 15.1405 92.5354 21.5805 90.7863L17.9919 85.168C10.3557 87.6061 4.87793 91.7051 4.87793 97.3234C4.87793 106.992 21.0287 112.195 36.2128 112.195C51.397 112.195 67.5433 106.992 67.5433 97.3234C67.5433 91.7051 62.07 87.6105 54.4779 85.2165H54.4823Z",
    fill: "url(#paint0_linear_750_3587)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9448 34.8011C71.4725 16.3957 56.6415 1.07323 38.2661 0.0573308C17.6042 -1.08666 0.5 15.3356 0.5 35.7463C0.5 42.2437 2.23028 48.3258 5.26269 53.5555L31.9894 95.0219C33.9801 98.1094 38.4956 98.1094 40.4863 95.0219L67.1954 53.5555C70.3735 48.0741 72.1214 41.6518 71.9448 34.8011ZM36.2224 53.1801C26.569 53.1801 18.7518 45.3444 18.7518 35.6978C18.7518 26.0511 26.569 18.1934 36.2224 18.1934C45.8758 18.1934 53.7018 26.0379 53.7018 35.6978C53.7018 45.3576 45.8846 53.1801 36.2224 53.1801Z",
    fill: "url(#paint1_linear_750_3587)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_750_3587",
    x1: 36.2106,
    y1: 85.168,
    x2: 36.2106,
    y2: 112.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_750_3587",
    x1: 36.2285,
    y1: 0.000976562,
    x2: 36.2285,
    y2: 97.3375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGps);
export default __webpack_public_path__ + "static/media/gps.1af48a3585c0e0663c7387d929bb2afe.svg";
export { ForwardRef as ReactComponent };